export default __webpack_public_path__ + "static/media/DSC_0530.8effade1.jpg";